<template>
  <div class="logs-container">
    <div
      class="wrapper"
      ref='wrapper'
    >
      <div
        ref='marquee'
        style="text-align: left;width: 2000px;"
      >
        <span ref='marqueeContent'>{{ info }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Logs',
  props: {
    stateInfoList: Array
  },
  data () {
    return {
      info: '',
      timer: null,
    }
  },
  watch: {
    'stateInfoList': {
      immediate: true,
      deep: true,
      handler: function (newVal, oldVal) {
        if (newVal.length > 0) {
          let tem = '';
          for (let ele of newVal) {
            tem = tem + ' ' + ele;
          }
          this.info = tem;
          // console.log(this.info);
          this.move();
        }
      }
    },
  },
  mounted () { },
  methods: {
    move () {
      if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
      }
      let wrapper = this.$refs.wrapper;
      let wrapperWidth = wrapper.getBoundingClientRect().width;
      let marquee = this.$refs.marquee;
      marquee.style.transform = 'translateX(' + wrapperWidth + 'px)';
      let marqueeContent = this.$refs.marqueeContent;
      let contentWidth = marqueeContent.getBoundingClientRect().width;
      let distance = wrapperWidth;
      this.timer = setInterval(() => {
        //当文字移动超出wrapper的左侧时 则归位
        if (marquee.getBoundingClientRect().x + contentWidth < wrapper.getBoundingClientRect().x) {
          distance = wrapperWidth;
        }
        distance--;
        if (this.$refs.marquee){
          this.$refs.marquee.style.transform = 'translateX(' + distance + 'px)';
        }
      }, 20);
    }
  }
}
</script>

<style scoped>
@font-face {
  font-family: "Alimama-ShuHeiTi";
  src: url("../../../assets/fonts/AlimamaShuHeiTi-Bold.ttf");
}

.logs-container {
  width: 650px;
  height: 25px;
  background-color: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.logs-container .wrapper {
  margin-top: 5px;
}

.logs-container span {
  color: #FF4040;
  font-family: "Alimama-ShuHeiTi";
}
</style>
